<template lang="pug">

div.prompt
  article(v-if="state === 0")
    div.heading Level of Difficulty
    div 1,2,3,4,5,6,7 - 0
    
    table(width="100%")
      tr
        td 1 = Easy
        td 7 = Hard
      tr
        td 4 = Average
        td 0 = Random
  article(v-else-if="state === 1")
    div.heading Maximum army size?
    div 1 to 8
    div 3/4 Recommended
  article(v-else-if="state === 2")
    div.heading Press any key to decide who plays first.
  article(v-else-if="state === 3 && !ready")
    div XYZ goes first.
  template(v-if="ready")
    article 
      div Armies = {{ }}
      div 
        label Dest / City: ?
        input(size="3") 
      div 
        label Num./Armies: ?
        input(size="3")
    article 
      div Action ? :
      div 1:(A)ction | 2:(P)ass | 3:(M)ove
      div (H)elp
    article
      div City/Attack ?: 
      div City/From ?:
    article
      div XYZ
      div Get's 123 Armies
    article 
      div xyz attacking sdfsf
      div source size 32 to 16 target size6

    article
      div Move 
      div Move/Many ?:
      div  14 armies
    article
      div [5] Attacking [7]
      div Again ? Y/N
      div $$ Armies
  footer
    button Next
</template>

<script>
import random from "lodash.random"
import { setTimeout } from "timers"
export default {
  name: "Prompter",
  components: {},
  props: {},
  data() {
    return {
      index: 0,
      ready: false,
      internalState: 0
    }
  },
  watch: {
    ready(value) {
      console.log("READY")
      if (this.turn === 0) {
      } else {
      }
    }
  },
  computed: {
    activeTurn() {
      return this.turn === 0
    },
    state() {
      if (this.level === -1) return 0
      if (this.startSize === -1) return 1
      if (this.turn === -1) return 2
      if (!this.ready) return 3
      return 4
    },
    turn() {
      return this.$store.state.game.turn
    },
    level: {
      get() {
        return this.$store.state.game.level
      },
      set(val) {
        this.$store.commit("setLevel", val === 0 ? random(1, 7, false) : val)
      }
    },
    startSize: {
      get() {
        return this.$store.state.game.startSize
      },
      set(val) {
        this.$store.commit(
          "updateStartSize",
          val === 8 ? random(1, 8, false) : val
        )
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", e => {
      let value = e.key
      if (this.state === 0 && [1, 2, 3, 4, 5, 6, 7, 0].includes(+value)) {
        this.level = +value
      } else if (
        this.state === 1 &&
        [1, 2, 3, 4, 5, 6, 7, 8].includes(+value)
      ) {
        this.startSize = +value
      } else if (this.state === 2) {
        this.$store.commit("setTurn", random(0, 3))

        setTimeout(() => {
          this.ready = true
        }, 1500)
      }
      console.log(e.key, e.keyCode, this.state)
    })
  }
}
</script>

<style lang="scss" scoped>
.prompt {
  width: 220px;
  padding: 5px;
  color: cyan;
  background-color: black;

  border: solid 1px lightblue;
  text-align: center;
  .heading {
    color: yellow;
    margin-bottom: 8px;
    text-align: left;
  }
  article {
    background-color: gray;
    margin: 2px 0;
  }
}
</style>
